<template>
  <div class="progress-bar">
    <div
      class="progress-percent"
      :style="`width: ${percent}%; background-color: ${progressColor}`"
      style="transition: all 0.5s ease-out"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DiagnosticProgressBar',
  computed: {
    percent() {
      if (this.focusDiagItem && this.focusDiagItem.path.length === 0) {
        return 100;
      }
      const currentDepth = this.diagPath.length;
      const maxDepth = currentDepth + this.maxDepthRemaining;

      if (currentDepth && maxDepth !== 0) {
        return Math.floor((currentDepth * 100) / maxDepth);
      }
      return 0;
    },
    progressColor() {
      if (this.maxDepthRemaining === 0) {
        return '#70e000';
      }
      return '#0081F9';
    },
    maxDepthRemaining() {
      let a = 0;
      if (this.focusNavItem.children !== undefined) {
        (function iter(depth, children) {
          if (a < depth) a = depth;
          children.forEach((child) => {
            if (child.children !== undefined) iter(depth + 1, child.children);
          });
        })(1, this.focusNavItem.children);
      }
      return a;
    },
    ...mapGetters('webKnowledgeModule', [
      'focusNavItem',
      'diagPath',
      'focusDiagItem',
    ]),
  },
  methods: {
    iter(depth, children) {
      if (this.maxDepth < depth) this.maxDepth = depth;
      children.forEach((child) => {
        if (child.children !== undefined) this.iter(depth + 1, child.children);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-percent {
  height: 2px;
  background-color: $blue-mayday;
}

.progress-bar {
  height: 2px;
  background-color: rgba($blue-mayday, 0.1);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
